import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
require('parsley');
require('datatables.net');
require('datatablesResponsive');
require('parsley');
import * as moment from 'moment';
import { bookingFormCommon } from "../c005-bookingform-common";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
var adobeDataLayer = new adobeDataLayerWrapper();
export class travellerpass {
	private addForm: any = $('#travel_pass');
	$scope: any = $('#travel_pass');
	addmy_showtrar: any;
	private bookingformcommon = new bookingFormCommon();
	private memberBase: any = new memberPortal(); $error: Array<any>;
	private pageType:any = null;

	init(): any {
		let _self = this;
		_self.addForm.find('#ibe-standalone-travelpass div').removeClass('form-group');
		$('#isSideTripEnable').val('No');
		_self.addForm.find('.travel-pass-info-return').removeClass('hide');
		$('#ibeWrapper #book-flight--container').remove();
		$('#bookingNav .book-flight').parent().remove();
		$('#bookingNav .mobile-book-flight').parent().remove();
		$('#ibeMobWrapper #mobile-bookflight--container').remove();
	}


	initSelectizeInputs(): any {
		let _self = this;
		let bcommon = _self.bookingformcommon;
		bcommon.preloader();
		if (_self.isLoggedinUserisChild()) {
			_self.addForm.find('.restrict-travelpass').removeClass('hide');
			_self.addForm.find('.purchase-travelpass').addClass('hide');
			_self.addForm.find('.members-content-container').addClass('hide');
			bcommon.preloaderClose();
		}
		else {
			_self.addForm.find('.restrict-travelpass').addClass('hide');
			var travel_passInput = $('#travel-pass--id');
			var gettravelpassOptions = $.Deferred();
			let travelpasscodeurl: string = $('[data-get-travel-pass-details]').attr('data-get-travel-pass-details');
			if (travelpasscodeurl) {
				$.get(travelpasscodeurl)
					.done((data: any) => {
						if ($.isEmptyObject(data)) {
							this.pageType = 'Enrich Fly Pass';
							adobeDataLayer.push('pageLoaded', {
								'pageName': '',
								'pageType': this.pageType,
								'attributes': []
							});
							_self.addForm.find('.purchase-travelpass').removeClass('hide');
							_self.addForm.find('.members-content-container').addClass('hide');
							bcommon.preloaderClose();
						}
						else {
							if (typeof data === 'string') {
								data = JSON.parse(data);
							}
							if (data.hasOwnProperty('message')) {
								bcommon.preloaderClose();
								$.magnificPopup.open({
									items: {
										src: '#flypass--error-popup'
									},
									type: 'inline',
									midClick: true,
									enableEscapeKey: false,
									showCloseBtn: false,
									closeOnBgClick: false,
									modal: true,
									callbacks: {
										open: function () {
											var $content = $(this.content);
											$content.find('.title').html(data.message);
											$content.on('click', '.flypass-msg-btn-refresh', function () {
												$.magnificPopup.close();
												location.reload();
											});
										}
									}
								}, 0);
							}
							else if (data.hasOwnProperty("travelPassInfo")) {
								if (data.travelPassInfo.length == 0) {
									_self.addForm.find('.purchase-travelpass').removeClass('hide');
									_self.addForm.find('.members-content-container').addClass('hide');
									bcommon.preloaderClose();
								} else {									
									_self.addForm.find('.purchase-travelpass').addClass('hide');
									_self.addForm.find('.members-content-container').removeClass('hide');
									var listItems = "<option value=''> </option>";
									if (typeof data === 'string') {
										data = JSON.parse(data);
									}
									for (var i = 0; i < data.travelPassInfo.length; i++) {
										listItems += "<option value='" + data.travelPassInfo[i].id + "|" + data.travelPassInfo[i].name + "|" + data.travelPassInfo[i].remainingQuota + "|" + data.travelPassInfo[i].zone + "|" + data.travelPassInfo[i].travelEndDate + "|" + data.travelPassInfo[i].skuId + "|" + data.travelPassInfo[i].expireDate + "|" + data.travelPassInfo[i].status + "'>" + data.travelPassInfo[i].id + "|" + "Credit Balance " + data.travelPassInfo[i].remainingQuota + "</option>";
									}
									gettravelpassOptions.resolve(listItems);
									bcommon.preloaderClose();
								}
							}
							else {
								_self.addForm.find('.purchase-travelpass').removeClass('hide');
								_self.addForm.find('.members-content-container').addClass('hide');
								bcommon.preloaderClose();
							}
						}

					})
					.fail((error: any) => {
						gettravelpassOptions.reject(error);
						bcommon.preloaderClose();
					});


				$.when(gettravelpassOptions).done(function (gettravelpassOptions: any) {
					travel_passInput.html(gettravelpassOptions);
					let inputSelectArr: any = $('#travel-pass--id');;
					_self.inittravelSelectizeInputs(inputSelectArr);
					bcommon.preloaderClose();
				});
			}
		}
	}

	isLoggedinUserisChild() {
		let _self = this;

		var data = {
			'action': 'fetch'
		};
		let age: any;
		$.ajax({
			type: 'POST',
			url: '/bin/services/new/getMembershipLCPAPI',
			data: data,
			async: false,
			success: function (msg: any) {
				let res;
				res = msg;
				res = JSON.parse(msg);
				if (!$.isEmptyObject(res)) {
					age = res.dob;
				}
			},
			error: function (msg: any) {
				console.log(msg);
			}
		});
		if (age != null) {
			if (moment().diff(age, 'years') < 12) {
				return true;
			}
		}
		return false;
	}

	inittravelSelectizeInputs(inputSelectArr: any): any {
		let _self = this;
		let $this: any = $(inputSelectArr);
		let $thisLabel: any = $this.parent().find('label');
		$this.selectize({
			valueField: 'value',
			labelField: 'text',
			searchField: ['text'],
			selectOnTab: true,
			onInitialize: () => {
				$this[0].selectize.$control_input.attr('name', $this[0].selectize.$input[0].id.split('--')[1]);
				$this[0].selectize.$control_input.attr('data-parsley-errors-container', '#' + $this[0].selectize.$input[0].id + '--error-container');
			},
			onFocus: () => {
				$thisLabel.addClass('input-filled');
				$($this[0].selectize.$control[0]).addClass('select-filled');
				let $toLocationChange = $('.travel-pass--id').find('option:selected').text();
				 {
					if ($toLocationChange !== '') {
						$this[0].selectize.clear();
					}
				}
			},
			onChange: (value: any) => {
				$thisLabel.addClass('input-filled');
				$($this[0].selectize.$control[0]).addClass('select-filled');
				if (value.length) {
					let currentDate: any = new Date();
					let tpExpiryDate: any = value.split('|')[6];
					let tpTravelDate: any = value.split('|')[4];
					let tpstatus: any = value.split('|')[7];
					let isValidTravelPass: boolean = true;
					if(tpstatus=='suspended')
					{
						isValidTravelPass = false;
						_self.addForm.find('#redeemflight .passedstatus_refund').addClass('hide');
						_self.addForm.find('#redeemflight .passedstatus').removeClass('hide');
						_self.addForm.find('#redeemflight .container:first').addClass('hide');
						_self.addForm.find('#redeemflight .noquota').addClass('hide');
						_self.addForm.find('#redeemflight .expiredtp').addClass('hide');
						_self.addForm.find('#redeemflight .passedtraveldate').addClass('hide');
						clearInputsforInvalidTravelPass();
					}
					else if(tpstatus=='refund')
					{
						isValidTravelPass = false;
						_self.addForm.find('#redeemflight .passedstatus_refund').removeClass('hide');
						_self.addForm.find('#redeemflight .passedstatus').addClass('hide');
						_self.addForm.find('#redeemflight .container:first').addClass('hide');
						_self.addForm.find('#redeemflight .noquota').addClass('hide');
						_self.addForm.find('#redeemflight .expiredtp').addClass('hide');
						_self.addForm.find('#redeemflight .passedtraveldate').addClass('hide');
						clearInputsforInvalidTravelPass();
					}					
					else
					{	
						_self.addForm.find('#redeemflight .passedstatus_refund').addClass('hide');		
						_self.addForm.find('#redeemflight .passedstatus').addClass('hide');				
						if (moment.utc(currentDate).isAfter(new Date(tpExpiryDate))) {
							isValidTravelPass = false;
							_self.addForm.find('#redeemflight .container:first').addClass('hide');
							_self.addForm.find('#redeemflight .noquota').addClass('hide');
							_self.addForm.find('#redeemflight .expiredtp').removeClass('hide');
							_self.addForm.find('#redeemflight .passedtraveldate').addClass('hide');
							clearInputsforInvalidTravelPass();
						}
						else if (moment.utc(currentDate).isAfter(new Date(tpTravelDate))) {
							isValidTravelPass = false;
							_self.addForm.find('#redeemflight .container:first').addClass('hide');
							_self.addForm.find('#redeemflight .noquota').addClass('hide');
							_self.addForm.find('#redeemflight .expiredtp').addClass('hide');
							_self.addForm.find('#redeemflight .passedtraveldate').removeClass('hide');
							clearInputsforInvalidTravelPass();
						}
					}
					if (isValidTravelPass) {
						if (value.split('|')[2].trim() > 0) {
							_self.addForm.find('#redeemflight .container:first').removeClass('hide');
							_self.addForm.find('#redeemflight .noquota').addClass('hide');
							_self.addForm.find('#redeemflight .expiredtp').addClass('hide');
							_self.addForm.find('#redeemflight .passedtraveldate').addClass('hide');
							if (value.split('|')[2].trim() < 2) {
								_self.addForm.find('.trip-type--container .returnTrip').addClass('hide');
								_self.addForm.find('.trip-type--container .oneWayTrip').trigger('click');
							} else {
								_self.addForm.find('.trip-type--container .returnTrip').removeClass('hide');
								_self.addForm.find('.trip-type--container .returnTrip').trigger('click');
							}
							_self.addForm.find('.returnTrip .departureDate').val('');
							_self.addForm.find('.returnDate').val('');
							_self.addForm.find('.oneWay-trip').val('');
							let tpMaxdays: any = new Date(value.split('|')[4]);
							let ibeNowDate: any = new Date();
							let maxTpDate: any = new Date(tpMaxdays.getFullYear(), tpMaxdays.getMonth(), tpMaxdays.getDate(), 0, 0, 0, 0);
							let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
							let maxIbeDate: any = new Date(ibeNowDate.getFullYear(), ibeNowDate.getMonth(), ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
							maxTpDate = maxTpDate > maxIbeDate ? maxIbeDate : maxTpDate;
							_self.addForm.find('.returnTrip .departureDate').datepicker('option', 'maxDate', maxTpDate);
							_self.addForm.find('.returnDate').datepicker('option', 'maxDate', maxTpDate);
							_self.addForm.find('.oneWay-trip').datepicker('option', 'maxDate', maxTpDate);
							_self.addForm.find('.returnTrip .departureDateMobile').datepicker('option', 'maxDate', maxTpDate);
							_self.addForm.find('.returnDateMobile').datepicker('option', 'maxDate', maxTpDate);
							_self.addForm.find('.departureDateMobile.oneway-trip').datepicker('option', 'maxDate', maxTpDate);
							_self.addForm.find('.form-group.travel-pass--redeem').removeClass('disablecontent');
							_self.addForm.find('.form-group.travel-pass--details').removeClass('disablecontent');
							_self.addForm.find('.travelpassname_desp').text(value.split('|')[1]);
							_self.addForm.find('.travelpassnbalance_desp').text(value.split('|')[2]);
							_self.addForm.find('.travelpassexpiry_desp').text(moment(value.split('|')[6]).format('DD-MMM-YYYY'));
							let $updateTypes: Array<any> = [];
							$updateTypes.push(_self.addForm.find('.ibe-from--location'));
							$updateTypes.push(_self.addForm.find('.ibe-to--location'));
							$updateTypes.push(_self.addForm.find('.ibe-mob-from--location'));
							$updateTypes.push(_self.addForm.find('.ibe-mob-to--location'));
							var $data: any = {
								zone: value.split('|')[3]
							};
							let airportList = this.bookingformcommon.getTravelPassAirPorts($data);
							if (airportList != null) {
								this.bookingformcommon.updateTravelPassAirportList('', $updateTypes, airportList);
							}
						} else {
							_self.addForm.find('#redeemflight .container:first').addClass('hide');
							_self.addForm.find('#redeemflight .noquota').removeClass('hide');
							_self.addForm.find('#redeemflight .expiredtp').addClass('hide');
							_self.addForm.find('#redeemflight .passedtraveldate').addClass('hide');
							clearInputsforInvalidTravelPass();
						}
					}
				}
				else {
					_self.addForm.find('.form-group.travel-pass--redeem').addClass('disablecontent');
					_self.addForm.find('.form-group.travel-pass--details').addClass('disablecontent');
					_self.addForm.find('.travelpassname_desp').html('&nbsp;');
					_self.addForm.find('.travelpassexpiry_desp').html('&nbsp;');
					_self.addForm.find('.travelpassnbalance_desp').html('&nbsp;');
					_self.addForm.find('.returnTrip .departureDate').val('');
					_self.addForm.find('.returnDate').val('');
					_self.addForm.find('.oneWay-trip').val('');
					_self.addForm.find('.returnTrip .departureDateMobile').val('');
					_self.addForm.find('.returnDateMobile').val('');
					_self.addForm.find('.departureDateMobile.oneway-trip').val('');
					let selectizefromLocation = _self.addForm.find('.ibe-from--location')[0].selectize;
					selectizefromLocation.clear();
					let selectizetoLocation = _self.addForm.find('.ibe-to--location')[0].selectize;
					selectizetoLocation.clear();
					let selectizefromLocationMob = _self.addForm.find('.ibe-mob-from--location')[0].selectize;
					selectizefromLocationMob.clear();
					let selectizetoLocationMob = _self.addForm.find('.ibe-mob-to--location')[0].selectize;
					selectizetoLocationMob.clear();

				}

				let ishist_active = $('.travel-pass--redeem li')[1];
				if ($(ishist_active).hasClass('active')) {
					$('#history_tab').trigger('click');
				}

				function clearInputsforInvalidTravelPass() {
					_self.addForm.find('.form-group.travel-pass--redeem').removeClass('disablecontent');
					_self.addForm.find('.form-group.travel-pass--details').removeClass('disablecontent');
					_self.addForm.find('.travelpassname_desp').text(value.split('|')[1]);
					_self.addForm.find('.travelpassnbalance_desp').text(value.split('|')[2]);
					_self.addForm.find('.travelpassexpiry_desp').text(moment(value.split('|')[6]).format('DD-MMM-YYYY'));
					_self.addForm.find('.returnTrip .departureDate').val('');
					_self.addForm.find('.returnDate').val('');
					_self.addForm.find('.oneWay-trip').val('');
					_self.addForm.find('.returnTrip .departureDateMobile').val('');
					_self.addForm.find('.returnDateMobile').val('');
					_self.addForm.find('.departureDateMobile.oneway-trip').val('');
					let selectizefromLocation = _self.addForm.find('.ibe-from--location')[0].selectize;
					selectizefromLocation.clear();
					let selectizetoLocation = _self.addForm.find('.ibe-to--location')[0].selectize;
					selectizetoLocation.clear();
					let selectizefromLocationMob = _self.addForm.find('.ibe-mob-from--location')[0].selectize;
					selectizefromLocationMob.clear();
					let selectizetoLocationMob = _self.addForm.find('.ibe-mob-to--location')[0].selectize;
					selectizetoLocationMob.clear();
					$("html, body").animate({ scrollTop: 250 });
				}

			},
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<p class = "travelpassnameselected"><span class = "travelpasslenselected">' + escape(item.text.split('|')[0].split('__')[0]) + '</span></p>' + '<p class = "travelpassnameselected"><span class = "travelpass_points">' + escape(item.text.split('|')[1]) + '</span></p>' : '') +
						'</div>';
				},
				option: function (item: any, escape: any) {
					let isActive = _self.travalpassStatus(item.value.split('|')[6]);
					let statusClass = isActive ? 'travelpass_status_active' : 'travelpass_status_expired'
					return '<div>' +
						(item.text ? '<div class = "travelpassname"><span class = "travelpasslen">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' + '<span class = "travelpass_name">' + escape(item.text.split('|')[1]) + '</span>' + '<span class = "travelpass_status ' + statusClass + '">' + escape(isActive ? 'Active' : 'Expired') + '</span>'  + '<p><span class = "travelpass_fullname">' + escape(item.value.split('|')[1] && item.value.split('|')[1]!='undefined'?item.value.split('|')[1]:'') + '</span></p></div>': '') +
						'</div>';
			
			},
			onBlur: () => {
				let $activeOptionChange: any = $this[0].selectize.getValue();

				if ($activeOptionChange == null || !$activeOptionChange.length) {
					$thisLabel.removeClass('input-filled');
					$($this[0].selectize.$control[0]).removeClass('select-filled');
				} else {
					$thisLabel.addClass('input-filled');
					$($this[0].selectize.$control[0]).addClass('select-filled');
				}
			},
			placeholder: 'Select your Fly Pass ID'
		});
	}

	travalpassStatus(expireDate:Date): any {
		let $expiredDate :any= moment.utc(expireDate);
		let $currentDate :any=  moment.utc(new Date());
		if($expiredDate >$currentDate)
		{
			return true
		}
		else {
			return false
		}
	}
	displaytravel_details(): any {
		let _self = this;
		let tooltipmessage:string = '<div><p>Travel Pass can only be booked for a single adult traveller.</p></div>';		
		$('.trans-infoicon').tooltip({content: tooltipmessage, track:true, tooltipClass:'tooltip-content'});
		_self.$scope.find('.showtraveller-histroy').click((evt: any) => {
			$(window).unbind('scroll');
			evt.preventDefault();
			evt.stopPropagation();
			$('#' + evt.target.id).parent().eq(0).children().eq(1).show();
			$('#' + evt.target.id).hide();
		});
		_self.$scope.find('.hidetraveller-histroy').click((evt: any) => {
			$(window).unbind('scroll');
			evt.preventDefault();
			evt.stopPropagation();
			$('#' + evt.target.id).parent().eq(0).hide();
			$('#' + evt.target.id).parent().parent().children().eq(2).show();
		});
	}
	populatehistory(): any {
		let $errorValidation = $('.error-validation').first();
		$('#history_tab').click((evt: any) => {
			let populateurl: string = $('[data-get-travel-pass-history]').attr('data-get-travel-pass-history');
			if (populateurl) {
				let $travelpass_id = $('select.travel-pass--id option')[0].value.split('|')[0];
				let $data = {
				}
				$data['TRAVELPASS_ID'] = $travelpass_id;
				$.ajax({
					type: 'get',
					url: populateurl,
					data: $data,
					success: function (msg: any) {
						if (Array.isArray(msg.travelPassHistory) && msg.travelPassHistory.length==0) {
							$("#travel_pass .history_error").removeClass('hide');
						}
						else {
							$("#travel_pass .history_error").addClass('hide');
						}
						if (Array.isArray(msg.travelPassHistory)&& msg.travelPassHistory.length>0)
						{	
							for (let i = 0; i < msg.travelPassHistory.length; i++) {
								var travelType = msg.travelPassHistory[i].tripType == 'R' ? "Return" : "Oneway";
								$("#history-from" + i).html(msg.travelPassHistory[i].origin);
								$("#history-fromdesp" + i).html("-" + "&nbsp" + msg.travelPassHistory[i].originDesc);
								$("#history-to" + i).html(msg.travelPassHistory[i].destination);
								$("#history-todesp" + i).html("-" + "&nbsp" + msg.travelPassHistory[i].destinationDesc);
								$("#history-traveldate" + i).html(msg.travelPassHistory[i].departDate);
								if (msg.travelPassHistory[i].tripType == 'R') {
									$("#history_returndate" + i).html(msg.travelPassHistory[i].returnDate);
								}
								$("#history-pnr" + i).html(msg.travelPassHistory[i].pnr);
								$("#history-triptype" + i).html(travelType);
								$("#history_tktno" + i).html(msg.travelPassHistory[i].ticketNumber);
								$("#history_status" + i).html(msg.travelPassHistory[i].status);
								$("#history-bookingdate" + i).html(msg.travelPassHistory[i].bookingDate);
								
								if(msg.travelPassHistory[i].status.toLowerCase() === 'reinstated') {
									$("#history_ptredeemed" + i).html('+' + Math.abs(msg.travelPassHistory[i].point));
									if($("#history_ptredeemed" + i).html()=='+2')
									{
										$("#history_ptredeemed" + i).addClass('history_ptsreintat');
										$("#history_status" + i).addClass('history_ptsreintat');
									}
									else
									{
										$("#history_ptredeemed" + i).addClass('history_ptsreintatno')
									}
								} 
								else {
									$("#history_ptredeemed" + i).html(Math.abs(msg.travelPassHistory[i].point));
									$("#history_ptredeemed" + i).addClass('history_ptsreintatno')
								}

								let showhistory = $('.travel_passhistory')[i];
								$(showhistory).css('display', 'block');

							}
							for (let i = msg.travelPassHistory.length; i < 8; i++) 
							{
								let asdsf = $('.travel_passhistory')[i];
								$(asdsf).css('display', 'none');
							}
						}
						else
						{
							$('.travel_passhistory').css('display', 'none');
						}
					},
					error: function (error: any) {
						$errorValidation.find(".validation-content").html("Sorry, a general error occurred. Please try again later.");
					}
				});
			}
			
		});
	}
	trackEvent() {
		$('.travel-pass--redeem ul li a').click(function () {
			let tabName = $(this).attr('href');
			if(tabName == '#redeemflight') {
				adobeDataLayer.push('click', {
					'pageName': '',
					'pageType': this.pageType,
					'clickName': 'click:tab-click:fly-pass-redeem-flight',
					'componentType': 'tab',
					'componentName': '',
					'componentID': '',
					'attributes': []
				});
			} else {
				adobeDataLayer.push('click', {
					'pageName': '',
					'pageType': this.pageType,
					'clickName': 'click:tab-click:fly-pass-history',
					'componentType': 'tab',
					'componentName': '',
					'componentID': '',
					'attributes': []
				});
			}
		});

	}
}
let scope: Element = document.querySelector('#travel_pass');

if (scope) {
	try {
		$.when(window['ibeOnDListNew']).done((listData: any) => {
			let travelpass = new travellerpass();
			travelpass.trackEvent();
			travelpass.init();
			travelpass.initSelectizeInputs();
			travelpass.displaytravel_details();
			travelpass.populatehistory();
			$('.travel-pass_history').hide();
			$('#history').children().eq(0).css({ 'margin-top': '10px' });
		});
	} catch (e) { console.error(e); }
}